module.exports = __webpack_public_path__ + "static/media/colorful_thumb.c0fa1962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colorful_thumb.jpg
// module id = 816
// module chunks = 0